'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var FormControl_module = require('../styles/FormControl.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The FormControl component is a utility component to help compose form fields
 *
 * @component
 * @example
 * ```jsx
 * <FormControl>content</FormControl>
 * ```
 */
const FormControl = React__namespace.forwardRef((props, ref) => {
    const { invalid = false, disabled = false, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(FormControl_module.default);
    const classNames = cx(className, 'container');
    const formControlContext = React__namespace.useMemo(() => ({ invalid, disabled }), [invalid, disabled]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "FormControl", className: classNames, ...restProps },
        React__namespace.createElement(reactUtils.FormControlProvider, { value: formControlContext }, children)));
});
FormControl.defaultProps = {};
FormControl.displayName = 'FormControl';

exports.FormControl = FormControl;
//# sourceMappingURL=FormControl.js.map
